<template src="./ProgressBarNormal.html"></template>
<script>
import {ref, watch} from "vue";

export default {
  name: 'ProgressBarNormal',
  props: {
    listStep: {
      type: Object,
      required: false,
      default: () => {}
    },
    step: {
      type: Number,
      required: false,
      default: () => 1
    },
  },
  setup(props) {
    const listStepCurrent = ref(props.listStep)
    const stepCurrent = ref(props.step)
    watch(() => props.listStep, (newStep) => {
      listStepCurrent.value = newStep
    });
    watch(() => props.step, (newStep) => {
      stepCurrent.value = newStep
    });

    function getClassStatus(status) {
      if(parseInt(status) === 1) {
        return '';
      }
      if(parseInt(status) === 2) {
        return 'active';
      }
      if(parseInt(status) === 3) {
        return 'complete-step';
      }
    }
    return {
      listStepCurrent,
      stepCurrent,
      getClassStatus
    }
  }
}
</script>
<style scoped lang="scss">
.progressbar {
  counter-reset: step;
  padding: 0;

  /* for demo */
  margin: 0 auto;
  max-width: 800px;
}

.progressbar li {
  float: left;
  list-style: none;
  position: relative;
  text-align: center;
  width: calc(100% / 5);
}

.progressbar li:before {
  background: #fff;
  border: 2px solid #bebebe;
  border-radius: 50%;
  color: #bebebe;
  content: counter(step);
  counter-increment: step;
  display: block;
  font-weight: 700;
  height: 30px;
  line-height: 27px;
  margin: 0 auto 10px;
  text-align: center;
  width: 30px;
  position: relative;
  z-index: 2;
}

.progressbar li:after {
  background: #979797;
  content: '';
  height: 3px;
  left: -50%;
  position: absolute;
  top: 15px;
  width: 100%;
  z-index: 0;
}

.progressbar li:first-child:after {
  content: none;
}

.progressbar li.active:after,
.progressbar li.complete-step:after {
  background: #696cff;
}
.progressbar li.active:before,
.progressbar li.complete-step:before {
  background: #696cff;
  border-color: #696cff;
  color: #fff;
}

.progressbar li.active {
  color: #696cff;
  font-weight: 700;
}

.progressbar li.complete-step {
  color: #696cff;
  font-weight: 700;
}
</style>